import { render, staticRenderFns } from "./PilotMovement.vue?vue&type=template&id=4b60fd61&scoped=true&"
import script from "./PilotMovement.vue?vue&type=script&lang=js&"
export * from "./PilotMovement.vue?vue&type=script&lang=js&"
import style0 from "./PilotMovement.vue?vue&type=style&index=0&id=4b60fd61&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b60fd61",
  null
  
)

export default component.exports